export const urlWithParameter = (url, param) => {
    if(url.includes('?')) {
        url += '&' + param;
    } else {
        url += '?' + param;
    }
    return url;
}
